import { CODON_TABLE } from "@/lib/science/codon-table";
import { cleanSequence } from "@/lib/science/sequence";

export interface TranslationResult {
  protein: string;
  /** number of complete codons read */
  codons: number;
  /** true if translation stopped at a stop codon (with stopAtStop) */
  truncated: boolean;
}

/**
 * Translate a DNA/RNA sequence to protein (single-letter codes). `frame` is
 * 0, 1 or 2. Unknown/incomplete codons become "X"; stop codons are "*". With
 * `stopAtStop`, translation ends at the first stop codon.
 */
export function translate(
  input: string,
  frame = 0,
  stopAtStop = false,
): TranslationResult {
  const seq = cleanSequence(input).replace(/U/g, "T");
  let protein = "";
  let codons = 0;
  let truncated = false;
  for (let i = frame; i + 3 <= seq.length; i += 3) {
    const codon = seq.slice(i, i + 3);
    const aa = CODON_TABLE[codon] ?? "X";
    codons++;
    if (aa === "*" && stopAtStop) {
      truncated = true;
      break;
    }
    protein += aa;
  }
  return { protein, codons, truncated };
}
